import { render, staticRenderFns } from "./roleType2.vue?vue&type=template&id=ce703228&scoped=true&"
import script from "./roleType2.vue?vue&type=script&lang=js&"
export * from "./roleType2.vue?vue&type=script&lang=js&"
import style0 from "./roleType2.vue?vue&type=style&index=0&id=ce703228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce703228",
  null
  
)

export default component.exports